<template>
  <div class="form-container">
    <div class="form-body">
      <!-- @TODO nice-to-have: separate static component for paymentDetails -->
      <div class="payment-preview">
        <div class="requested-details flex justify-between">
          <div class="flex-column" id="paymentRequestDate">
            <h2>
              {{ paymentDetails.requestDate }}
            </h2>
            <small>Date requested</small>
          </div>
          <div class="flex-column" id="paymentBalanceDue">
            <h2>${{ formatAmountStr(paymentDetails.amount) }}</h2>
            <small>Balance due</small>
          </div>
        </div>
        <div class="payment-details" id="paymentBillingReason">
          <p>Billing Reason:</p>
          <p>{{ paymentDetails.reason }}</p>
        </div>
        <!-- @TODO nice-to-have: separate component. CORE-973 would make the credit card options dynamic. allowing the provider to set them. -->
        <div class="options">
          <div class="container flex justify-between">
            <small>Accepted payments:</small>
            <div class="flex cards">
              <svg viewBox="0 0 30 20">
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g id="icon-amex">
                    <path
                      d="M29.6311475,17.3170732 C29.6311475,18.6585366 28.5245902,19.7560976 27.1721311,19.7560976 L2.58196721,19.7560976 C1.2295082,19.7560976 0.12295082,18.6585366 0.12295082,17.3170732 L0.12295082,2.68292683 C0.12295082,1.34146341 1.2295082,0.243902439 2.58196721,0.243902439 L27.1721311,0.243902439 C28.5245902,0.243902439 29.6311475,1.34146341 29.6311475,2.68292683 L29.6311475,17.3170732"
                      fill="#5EC1EC"
                    ></path>
                    <path
                      d="M28.9086885,0.960487805 C29.3542623,1.40243902 29.6311475,2.01219512 29.6311475,2.68292683 L29.6311475,17.3170732 C29.6311475,17.9878049 29.3542623,18.597561 28.9086885,19.0395122 C28.462623,19.4819512 27.8483607,19.7560976 27.1721311,19.7560976 L2.58196721,19.7560976 C1.9057377,19.7560976 1.29098361,19.4819512 0.845409836,19.0395122 L28.9086885,0.960487805"
                      fill="#5BBBE6"
                    ></path>
                    <path
                      d="M8.75655738,12.4009756 L8.53180328,11.5521951 L7.04901639,11.5521951 L6.81786885,12.4009756 L5.46295082,12.4009756 L6.95213115,7.85560976 L8.59819672,7.85560976 L10.1045902,12.4009756 L8.75655738,12.4009756 L8.75655738,12.4009756 Z M8.27606557,10.5487805 L8.07934426,9.80585366 C8.03311475,9.64097561 7.97803279,9.42780488 7.91213115,9.16536585 C7.84672131,8.90292683 7.80344262,8.71512195 7.78229508,8.60195122 C7.76409836,8.70731707 7.72672131,8.8804878 7.67163934,9.12195122 C7.61655738,9.36341463 7.49409836,9.8395122 7.3047541,10.5492683 L8.27606557,10.5487805 L8.27606557,10.5487805 Z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M12.5872131,12.4009756 L11.6547541,9.14 L11.6257377,9.14 C11.6690164,9.69512195 11.6911475,10.1263415 11.6911475,10.4346341 L11.6911475,12.4004878 L10.5988525,12.4004878 L10.5988525,7.87317073 L12.2404918,7.87317073 L13.1936066,11.0878049 L13.2186885,11.0878049 L14.1516393,7.87317073 L15.7972131,7.87317073 L15.7972131,12.4004878 L14.6636066,12.4004878 L14.6636066,10.4156098 C14.6636066,10.3126829 14.6655738,10.1995122 14.6685246,10.0721951 C14.6714754,9.94585366 14.6857377,9.63756098 14.7108197,9.14634146 L14.6822951,9.14634146 L13.7616393,12.4009756 L12.5872131,12.4009756"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M19.3618033,12.4009756 L16.6519672,12.4009756 L16.6519672,7.87365854 L19.3618033,7.87365854 L19.3618033,8.85560976 L17.8844262,8.85560976 L17.8844262,9.56780488 L19.2521311,9.56780488 L19.2521311,10.5492683 L17.8844262,10.5492683 L17.8844262,11.4039024 L19.3618033,11.4039024 L19.3618033,12.4009756"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M24.2719672,12.4009756 L22.8472131,12.4009756 L21.9560656,10.9863415 L21.0762295,12.4009756 L19.6804918,12.4009756 L21.1942623,10.084878 L19.7704918,7.87365854 L21.1381967,7.87365854 L21.962459,9.27317073 L22.7537705,7.87365854 L24.1618033,7.87365854 L22.7168852,10.1804878 L24.2719672,12.4009756"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M8.75655738,12.4009756 L8.53180328,11.5521951 L7.04901639,11.5521951 L6.81786885,12.4009756 L5.46295082,12.4009756 L6.95213115,7.85560976 L8.59819672,7.85560976 L10.1045902,12.4009756 L8.75655738,12.4009756 L8.75655738,12.4009756 Z M8.27606557,10.5487805 L8.07934426,9.80585366 C8.03311475,9.64097561 7.97803279,9.42780488 7.91213115,9.16536585 C7.84672131,8.90292683 7.80344262,8.71512195 7.78229508,8.60195122 C7.76409836,8.70731707 7.72672131,8.8804878 7.67163934,9.12195122 C7.61655738,9.36341463 7.49409836,9.8395122 7.3047541,10.5492683 L8.27606557,10.5487805 L8.27606557,10.5487805 Z"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M12.5872131,12.4009756 L11.6547541,9.14 L11.6257377,9.14 C11.6690164,9.69512195 11.6911475,10.1263415 11.6911475,10.4346341 L11.6911475,12.4004878 L10.5988525,12.4004878 L10.5988525,7.87317073 L12.2404918,7.87317073 L13.1936066,11.0878049 L13.2186885,11.0878049 L14.1516393,7.87317073 L15.7972131,7.87317073 L15.7972131,12.4004878 L14.6636066,12.4004878 L14.6636066,10.4156098 C14.6636066,10.3126829 14.6655738,10.1995122 14.6685246,10.0721951 C14.6714754,9.94585366 14.6857377,9.63756098 14.7108197,9.14634146 L14.6822951,9.14634146 L13.7616393,12.4009756 L12.5872131,12.4009756"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M19.3618033,12.4009756 L16.6519672,12.4009756 L16.6519672,7.87365854 L19.3618033,7.87365854 L19.3618033,8.85560976 L17.8844262,8.85560976 L17.8844262,9.56780488 L19.2521311,9.56780488 L19.2521311,10.5492683 L17.8844262,10.5492683 L17.8844262,11.4039024 L19.3618033,11.4039024 L19.3618033,12.4009756"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M24.2719672,12.4009756 L22.8472131,12.4009756 L21.9560656,10.9863415 L21.0762295,12.4009756 L19.6804918,12.4009756 L21.1942623,10.084878 L19.7704918,7.87365854 L21.1381967,7.87365854 L21.962459,9.27317073 L22.7537705,7.87365854 L24.1618033,7.87365854 L22.7168852,10.1804878 L24.2719672,12.4009756"
                      fill="#FFFFFF"
                    ></path>
                    <path id="Fill-11" fill="#56B1D9"></path>
                    <path
                      d="M27.1721311,0.731707317 C28.2570492,0.731707317 29.1393443,1.60682927 29.1393443,2.68292683 L29.1393443,17.3170732 C29.1393443,18.3931707 28.2570492,19.2682927 27.1721311,19.2682927 L2.58196721,19.2682927 C1.49704918,19.2682927 0.614754098,18.3931707 0.614754098,17.3170732 L0.614754098,2.68292683 C0.614754098,1.60682927 1.49704918,0.731707317 2.58196721,0.731707317 L27.1721311,0.731707317 M27.1721311,0.243902439 L2.58196721,0.243902439 C1.2295082,0.243902439 0.12295082,1.34146341 0.12295082,2.68292683 L0.12295082,17.3170732 C0.12295082,18.6585366 1.2295082,19.7560976 2.58196721,19.7560976 L27.1721311,19.7560976 C28.5245902,19.7560976 29.6311475,18.6585366 29.6311475,17.3170732 L29.6311475,2.68292683 C29.6311475,1.34146341 28.5245902,0.243902439 27.1721311,0.243902439"
                      fill="#9BCEE0"
                    ></path>
                  </g>
                </g>
              </svg>
              <svg viewBox="0 0 30 20">
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g id="icon-discover">
                    <path
                      d="M29.6311475,17.3170732 C29.6311475,18.6585366 28.5245902,19.7560976 27.1721311,19.7560976 L2.58196721,19.7560976 C1.2295082,19.7560976 0.12295082,18.6585366 0.12295082,17.3170732 L0.12295082,2.68292683 C0.12295082,1.34146341 1.2295082,0.243902439 2.58196721,0.243902439 L27.1721311,0.243902439 C28.5245902,0.243902439 29.6311475,1.34146341 29.6311475,2.68292683 L29.6311475,17.3170732"
                      fill="#FFF9F0"
                    ></path>
                    <path
                      d="M7.56639344,9.97219512 C7.56639344,10.4609756 7.42622951,10.835122 7.14639344,11.095122 C6.86557377,11.3546341 6.45983607,11.484878 5.92967213,11.484878 L5.08180328,11.484878 L5.08180328,8.51658537 L6.02114754,8.51658537 C6.51,8.51658537 6.88918033,8.64487805 7.15819672,8.9004878 C7.43114754,9.15609756 7.56639344,9.51365854 7.56639344,9.97219512 L7.56639344,9.97219512 Z M6.90737705,9.98878049 C6.90737705,9.35121951 6.62311475,9.03268293 6.05704918,9.03268293 L5.71868852,9.03268293 L5.71868852,10.964878 L5.99114754,10.964878 C6.60196721,10.964878 6.90737705,10.6390244 6.90737705,9.98878049 L6.90737705,9.98878049 Z"
                      fill="#414042"
                    ></path>
                    <path
                      d="M8.10295082,8.51658537 L8.73737705,8.51658537 L8.73737705,11.484878 L8.10295082,11.484878 L8.10295082,8.51658537 Z"
                      fill="#414042"
                    ></path>
                    <path
                      d="M11.2578689,10.66 C11.2578689,10.9287805 11.1619672,11.1395122 10.9657377,11.2936585 C10.7709836,11.4482927 10.5009836,11.5273171 10.1552459,11.5273171 C9.83655738,11.5273171 9.55229508,11.4673171 9.30639344,11.3502439 L9.30639344,10.764878 C9.50852459,10.855122 9.67967213,10.9170732 9.81934426,10.9546341 C9.95901639,10.9907317 10.087377,11.0087805 10.2034426,11.0087805 C10.3421311,11.0087805 10.4493443,10.9809756 10.5236066,10.9297561 C10.5954098,10.877561 10.6352459,10.797561 10.6352459,10.6946341 C10.6352459,10.6365854 10.6190164,10.584878 10.5855738,10.5390244 C10.5536066,10.4936585 10.504918,10.4497561 10.4404918,10.4082927 C10.3765574,10.3668293 10.2472131,10.2990244 10.0534426,10.2073171 C9.87098361,10.1219512 9.7342623,10.0395122 9.64180328,9.96146341 C9.54934426,9.88341463 9.47655738,9.79219512 9.42295082,9.68731707 C9.36836066,9.58243902 9.34131148,9.4604878 9.34131148,9.32146341 C9.34131148,9.05902439 9.43081967,8.85268293 9.61032787,8.70243902 C9.79032787,8.55170732 10.0377049,8.47707317 10.354918,8.47707317 C10.5103279,8.47707317 10.6588525,8.49512195 10.8,8.53170732 C10.9411475,8.56780488 11.0891803,8.62 11.2431148,8.68585366 L11.0385246,9.17512195 C10.8786885,9.1102439 10.744918,9.06390244 10.6406557,9.03902439 C10.5359016,9.01365854 10.4331148,9.0004878 10.3327869,9.0004878 C10.2122951,9.0004878 10.1198361,9.02780488 10.0563934,9.08390244 C9.99196721,9.1395122 9.96,9.21170732 9.96,9.30097561 C9.96,9.35658537 9.97278689,9.40439024 9.99885246,9.44634146 C10.024918,9.48780488 10.0662295,9.52731707 10.1227869,9.56585366 C10.1793443,9.60439024 10.3140984,9.67365854 10.525082,9.77414634 C10.8034426,9.90682927 10.9962295,10.04 11.1004918,10.1731707 C11.2057377,10.3034146 11.2578689,10.4668293 11.2578689,10.66"
                      fill="#414042"
                    ></path>
                    <path
                      d="M13.0711475,8.99756098 C12.8321311,8.99756098 12.6477049,9.08731707 12.5163934,9.26439024 C12.3836066,9.44243902 12.3201639,9.69121951 12.3201639,10.0087805 C12.3201639,10.6702439 12.5704918,11.0014634 13.0711475,11.0014634 C13.2816393,11.0014634 13.5354098,10.9507317 13.834918,10.844878 L13.834918,11.3731707 C13.5890164,11.4746341 13.3145902,11.5253659 13.0116393,11.5253659 C12.5763934,11.5253659 12.2429508,11.3936585 12.0127869,11.1317073 C11.7821311,10.8702439 11.6670492,10.4946341 11.6670492,10.0039024 C11.6670492,9.69512195 11.7240984,9.42487805 11.8386885,9.19317073 C11.9513115,8.96 12.1145902,8.78292683 12.3270492,8.65902439 C12.5395082,8.53512195 12.7878689,8.47317073 13.0731148,8.47317073 C13.3637705,8.47317073 13.6563934,8.54292683 13.9490164,8.68243902 L13.7444262,9.19414634 C13.6318033,9.14146341 13.5201639,9.09560976 13.4060656,9.05609756 C13.2914754,9.01658537 13.1803279,8.99756098 13.0711475,8.99756098"
                      fill="#414042"
                    ></path>
                    <path
                      d="M18.9142623,8.51658537 L19.555082,8.51658537 L18.5395082,11.484878 L17.847541,11.484878 L16.832459,8.51658537 L17.4747541,8.51658537 L18.0378689,10.2829268 C18.0688525,10.3878049 18.1022951,10.5082927 18.1352459,10.6478049 C18.1677049,10.7868293 18.1888525,10.882439 18.1977049,10.9365854 C18.212459,10.8121951 18.2636066,10.5956098 18.3516393,10.2829268 L18.9142623,8.51658537"
                      fill="#414042"
                    ></path>
                    <path
                      d="M21.655082,11.484878 L19.9313115,11.484878 L19.9313115,8.51658537 L21.655082,8.51658537 L21.655082,9.03268293 L20.5657377,9.03268293 L20.5657377,9.68439024 L21.5798361,9.68439024 L21.5798361,10.2 L20.5657377,10.2 L20.5657377,10.964878 L21.655082,10.964878 L21.655082,11.484878"
                      fill="#414042"
                    ></path>
                    <path
                      d="M22.9140984,10.3458537 L22.9140984,11.484878 L22.2796721,11.484878 L22.2796721,8.51658537 L23.1516393,8.51658537 C23.5583607,8.51658537 23.8588525,8.5897561 24.0545902,8.73707317 C24.2493443,8.88390244 24.3472131,9.10634146 24.3472131,9.40585366 C24.3472131,9.58 24.2985246,9.73609756 24.2021311,9.87170732 C24.1052459,10.0078049 23.9680328,10.1146341 23.7909836,10.1917073 C24.2409836,10.8580488 24.5340984,11.2902439 24.6708197,11.4843902 L23.9665574,11.4843902 L23.2519672,10.3453659 L22.9140984,10.3458537 M22.9140984,9.83414634 L23.1191803,9.83414634 C23.3193443,9.83414634 23.4678689,9.80097561 23.5632787,9.73512195 C23.6581967,9.66829268 23.7063934,9.56390244 23.7063934,9.42195122 C23.7063934,9.28097561 23.6562295,9.18146341 23.5598361,9.12146341 C23.462459,9.06146341 23.3114754,9.03219512 23.1068852,9.03219512 L22.9121311,9.03219512 L22.9140984,9.83414634"
                      fill="#414042"
                    ></path>
                    <path
                      d="M15.4013115,8.51658537 C16.2280328,8.51658537 16.8978689,9.18097561 16.8978689,10.0009756 C16.8978689,10.8209756 16.2280328,11.4853659 15.4013115,11.4853659 C14.575082,11.4853659 13.9047541,10.8209756 13.9047541,10.0009756 C13.9047541,9.18097561 14.575082,8.51658537 15.4013115,8.51658537"
                      fill="#E6A124"
                    ></path>
                    <path
                      d="M29.6311475,13.6585366 L29.6311475,17.3170732 C29.6311475,17.6526829 29.5618033,17.9726829 29.437377,18.2639024 C29.3104918,18.555122 29.1314754,18.8185366 28.9086885,19.0395122 C28.6859016,19.2604878 28.4208197,19.4390244 28.1267213,19.5639024 C27.8311475,19.6873171 27.51,19.7560976 27.1721311,19.7560976 L5.08327869,19.7560976 L29.6311475,13.6585366"
                      fill="#E6A124"
                    ></path>
                    <path
                      d="M0.845409836,19.0395122 L0.845409836,19.0395122 C1.27918033,19.4697561 1.87229508,19.7409756 2.52688525,19.7556098 C1.87229508,19.7409756 1.27918033,19.4697561 0.845409836,19.0395122 M28.9086885,0.960487805 L28.9086885,0.960487805 C28.9529508,1.00439024 28.9957377,1.0497561 29.0360656,1.09658537 C28.9957377,1.0497561 28.9529508,1.00439024 28.9086885,0.960487805"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M19.9313115,11.484878 L19.9313115,8.51658537 L21.655082,8.51658537 L21.655082,9.03268293 L20.5657377,9.03268293 L20.5657377,9.68439024 L21.5798361,9.68439024 L21.5798361,10.2 L20.5657377,10.2 L20.5657377,10.964878 L21.655082,10.964878 L21.655082,11.484878 L19.9313115,11.484878 M22.2796721,11.484878 L22.2796721,8.51658537 L23.1516393,8.51658537 C23.5583607,8.51658537 23.8588525,8.5897561 24.0545902,8.73707317 C24.2493443,8.88390244 24.3472131,9.10634146 24.3472131,9.40585366 C24.3472131,9.58 24.2985246,9.73609756 24.2021311,9.87170732 C24.1052459,10.0078049 23.9680328,10.1146341 23.7909836,10.1917073 C24.2409836,10.8580488 24.5340984,11.2902439 24.6708197,11.4843902 L23.9665574,11.4843902 L23.2519672,10.3453659 L22.9140984,10.3458537 L22.9140984,11.484878 L22.2796721,11.484878 M28.9086885,0.960487805 L17.1796721,8.51658537 L17.4747541,8.51658537 L18.0378689,10.2829268 C18.0688525,10.3878049 18.1022951,10.5082927 18.1352459,10.6478049 C18.1677049,10.7868293 18.1888525,10.882439 18.1977049,10.9365854 C18.212459,10.8121951 18.2636066,10.5956098 18.3516393,10.2829268 L18.9142623,8.51658537 L19.555082,8.51658537 L18.5395082,11.484878 L17.847541,11.484878 L16.894918,8.7 L16.477377,8.96926829 C16.737541,9.23609756 16.8978689,9.6 16.8978689,10.0009756 C16.8978689,10.8209756 16.2280328,11.4853659 15.4013115,11.4853659 C14.7727869,11.4853659 14.2347541,11.1009756 14.0134426,10.5565854 L13.3672131,10.9726829 C13.5083607,10.9473171 13.6637705,10.9053659 13.834918,10.844878 L13.834918,11.3731707 C13.5890164,11.4746341 13.3145902,11.5253659 13.0116393,11.5253659 C12.8572131,11.5253659 12.715082,11.5087805 12.5867213,11.4756098 L0.845409836,19.0395122 C1.27918033,19.4697561 1.87229508,19.7409756 2.52688525,19.7556098 C2.54508197,19.7560976 2.56377049,19.7560976 2.58196721,19.7560976 L5.08327869,19.7560976 L29.6311475,13.6585366 L29.6311475,2.68292683 C29.6311475,2.07853659 29.4068852,1.52390244 29.0360656,1.09658537 C28.9957377,1.0497561 28.9529508,1.00439024 28.9086885,0.960487805"
                      fill="#FFF9F1"
                    ></path>
                    <path
                      d="M13.834918,10.844878 C13.6637705,10.9053659 13.5083607,10.9473171 13.3672131,10.9726829 L12.5867213,11.4756098 C12.715082,11.5087805 12.8572131,11.5253659 13.0116393,11.5253659 C13.3145902,11.5253659 13.5890164,11.4746341 13.834918,11.3731707 L13.834918,10.844878"
                      fill="#504F51"
                    ></path>
                    <path
                      d="M19.555082,8.51658537 L18.9142623,8.51658537 L18.3516393,10.2829268 C18.2636066,10.5956098 18.212459,10.8121951 18.1977049,10.9365854 C18.1888525,10.882439 18.1677049,10.7868293 18.1352459,10.6478049 C18.1022951,10.5082927 18.0688525,10.3878049 18.0378689,10.2829268 L17.4747541,8.51658537 L17.1796721,8.51658537 L16.894918,8.7 L17.847541,11.484878 L18.5395082,11.484878 L19.555082,8.51658537"
                      fill="#504F51"
                    ></path>
                    <path
                      d="M21.655082,8.51658537 L19.9313115,8.51658537 L19.9313115,11.484878 L21.655082,11.484878 L21.655082,10.964878 L20.5657377,10.964878 L20.5657377,10.2 L21.5798361,10.2 L21.5798361,9.68439024 L20.5657377,9.68439024 L20.5657377,9.03268293 L21.655082,9.03268293 L21.655082,8.51658537"
                      fill="#504F51"
                    ></path>
                    <path
                      d="M23.1068852,9.03219512 L22.9121311,9.03219512 L22.9140984,9.83414634 L23.1191803,9.83414634 C23.3193443,9.83414634 23.4678689,9.80097561 23.5632787,9.73512195 C23.6581967,9.66829268 23.7063934,9.56390244 23.7063934,9.42195122 C23.7063934,9.28097561 23.6562295,9.18146341 23.5598361,9.12146341 C23.462459,9.06146341 23.3114754,9.03219512 23.1068852,9.03219512"
                      fill="#FFF9F1"
                    ></path>
                    <path
                      d="M22.9140984,9.83414634 L22.9121311,9.03219512 L23.1068852,9.03219512 C23.3114754,9.03219512 23.462459,9.06146341 23.5598361,9.12146341 C23.6562295,9.18146341 23.7063934,9.28097561 23.7063934,9.42195122 C23.7063934,9.56390244 23.6581967,9.66829268 23.5632787,9.73512195 C23.4678689,9.80097561 23.3193443,9.83414634 23.1191803,9.83414634 L22.9140984,9.83414634 M23.1516393,8.51658537 L22.2796721,8.51658537 L22.2796721,11.484878 L22.9140984,11.484878 L22.9140984,10.3458537 L23.2519672,10.3453659 L23.9665574,11.4843902 L24.6708197,11.4843902 C24.5340984,11.2902439 24.2409836,10.8580488 23.7909836,10.1917073 C23.9680328,10.1146341 24.1052459,10.0078049 24.2021311,9.87170732 C24.2985246,9.73609756 24.3472131,9.58 24.3472131,9.40585366 C24.3472131,9.10634146 24.2493443,8.88390244 24.0545902,8.73707317 C23.8588525,8.5897561 23.5583607,8.51658537 23.1516393,8.51658537"
                      fill="#504F51"
                    ></path>
                    <path
                      fill="#FFFFFF"
                      d="M29.2155738,18.6692683 C29.1359016,18.7878049 29.0459016,18.8980488 28.9470492,19.0004878 C28.9347541,19.0136585 28.9219672,19.0268293 28.9086885,19.0395122 C29.0227869,18.9268293 29.1260656,18.802439 29.2155738,18.6692683"
                    ></path>
                    <path
                      d="M28.772459,19.164878 C28.5890164,19.3214634 28.3819672,19.4512195 28.1581967,19.5502439 C28.3819672,19.4521951 28.5890164,19.3214634 28.772459,19.164878 M29.6306557,17.3643902 C29.6242623,17.682439 29.5563934,17.9863415 29.437377,18.2639024 C29.317377,18.5380488 29.1521311,18.7882927 28.9470492,19.0004878 C29.0459016,18.8980488 29.1359016,18.7878049 29.2155738,18.6692683 C29.4698361,18.2941463 29.6218033,17.8458537 29.6306557,17.3643902"
                      fill="#FFF9F1"
                    ></path>
                    <path
                      fill="#FFF9F1"
                      d="M28.0927869,19.577561 C27.8065574,19.6926829 27.4972131,19.7560976 27.1721311,19.7560976 C27.1918033,19.7560976 27.2114754,19.7556098 27.2306557,19.755122 C27.2390164,19.755122 27.2468852,19.755122 27.2557377,19.7546341 C27.5503279,19.744878 27.832623,19.6829268 28.0927869,19.577561"
                    ></path>
                    <path
                      d="M16.477377,8.96926829 L14.0134426,10.5565854 C14.2347541,11.1009756 14.7727869,11.4853659 15.4013115,11.4853659 C16.2280328,11.4853659 16.8978689,10.8209756 16.8978689,10.0009756 C16.8978689,9.6 16.737541,9.23609756 16.477377,8.96926829"
                      fill="#E8A835"
                    ></path>
                    <path
                      d="M29.6311475,13.6585366 L29.6311475,13.6585366 L5.08327869,19.7560976 L27.1721311,19.7560976 C27.4972131,19.7560976 27.8065574,19.6926829 28.0927869,19.577561 C28.114918,19.5687805 28.1365574,19.56 28.1581967,19.5502439 C28.3819672,19.4512195 28.5890164,19.3214634 28.772459,19.164878 C28.8196721,19.124878 28.864918,19.0829268 28.9086885,19.0395122 C28.9219672,19.0268293 28.9347541,19.0136585 28.9470492,19.0004878 C29.1521311,18.7882927 29.317377,18.5380488 29.437377,18.2639024 C29.5563934,17.9863415 29.6242623,17.682439 29.6306557,17.3643902 C29.6311475,17.3487805 29.6311475,17.3326829 29.6311475,17.3170732 L29.6311475,13.6585366"
                      fill="#E8A835"
                    ></path>
                    <path
                      d="M27.1721311,0.731707317 C28.2570492,0.731707317 29.1393443,1.60682927 29.1393443,2.68292683 L29.1393443,17.3170732 C29.1393443,18.3931707 28.2570492,19.2682927 27.1721311,19.2682927 L2.58196721,19.2682927 C1.49704918,19.2682927 0.614754098,18.3931707 0.614754098,17.3170732 L0.614754098,2.68292683 C0.614754098,1.60682927 1.49704918,0.731707317 2.58196721,0.731707317 L27.1721311,0.731707317 M27.1721311,0.243902439 L2.58196721,0.243902439 C1.2295082,0.243902439 0.12295082,1.34146341 0.12295082,2.68292683 L0.12295082,17.3170732 C0.12295082,18.6585366 1.2295082,19.7560976 2.58196721,19.7560976 L27.1721311,19.7560976 C28.5245902,19.7560976 29.6311475,18.6585366 29.6311475,17.3170732 L29.6311475,2.68292683 C29.6311475,1.34146341 28.5245902,0.243902439 27.1721311,0.243902439"
                      fill="#F8F6F2"
                    ></path>
                  </g>
                </g>
              </svg>
              <svg viewBox="0 0 30 20">
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g id="icon-mc">
                    <path
                      d="M29.6311475,17.3170732 C29.6311475,18.6585366 28.5245902,19.7560976 27.1721311,19.7560976 L2.58196721,19.7560976 C1.2295082,19.7560976 0.12295082,18.6585366 0.12295082,17.3170732 L0.12295082,2.68292683 C0.12295082,1.34146341 1.2295082,0.243902439 2.58196721,0.243902439 L27.1721311,0.243902439 C28.5245902,0.243902439 29.6311475,1.34146341 29.6311475,2.68292683 L29.6311475,17.3170732"
                      fill="#5565AF"
                    ></path>
                    <path
                      d="M1.66327869,19.5785366 C1.66967213,19.5814634 1.67606557,19.5839024 1.68245902,19.5858537 C1.67606557,19.5839024 1.66967213,19.5814634 1.66327869,19.5785366 M0.845409836,19.0395122 L0.845409836,19.0395122 C1.07508197,19.2673171 1.35,19.4507317 1.65491803,19.575122 C1.35,19.4507317 1.07508197,19.2673171 0.845409836,19.0395122 M29.6311475,17.3326829 C29.6267213,17.997561 29.3513115,18.6009756 28.9086885,19.0395122 C29.3513115,18.6009756 29.6267213,17.997561 29.6311475,17.3326829"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M28.9086885,0.960487805 L0.845409836,19.0395122 C1.07508197,19.2673171 1.35,19.4507317 1.65491803,19.575122 C1.65786885,19.5760976 1.66032787,19.577561 1.66327869,19.5785366 C1.66967213,19.5814634 1.67606557,19.5839024 1.68245902,19.5858537 C1.96131148,19.6956098 2.2647541,19.7560976 2.58196721,19.7560976 L27.1721311,19.7560976 C27.8483607,19.7560976 28.462623,19.4819512 28.9086885,19.0395122 C29.3513115,18.6009756 29.6267213,17.997561 29.6311475,17.3326829 L29.6311475,17.3170732 L29.6311475,2.68292683 L29.6311475,2.6595122 C29.6247541,1.99804878 29.3488525,1.39707317 28.9086885,0.960487805"
                      fill="#5C6BB2"
                    ></path>
                    <path
                      d="M14.8770492,6.7804878 C13.9755738,5.76585366 12.6590164,5.12195122 11.1885246,5.12195122 C8.47278689,5.12195122 6.2704918,7.30585366 6.2704918,10 C6.2704918,12.6936585 8.47278689,14.8780488 11.1885246,14.8780488 C12.6590164,14.8780488 13.9755738,14.2341463 14.8770492,13.2195122 C14.1137705,12.3595122 13.647541,11.2370732 13.647541,10 C13.647541,8.76292683 14.1137705,7.64 14.8770492,6.7804878"
                      fill="#EB564B"
                    ></path>
                    <path
                      d="M14.8770492,6.7804878 C14.1137705,7.64 13.647541,8.76439024 13.647541,10 C13.647541,11.2356098 14.1137705,12.3595122 14.8770492,13.2195122 C15.6403279,12.3595122 16.1065574,11.2370732 16.1065574,10 C16.1065574,8.76292683 15.6403279,7.64 14.8770492,6.7804878"
                      fill="#EB564B"
                    ></path>
                    <path
                      d="M18.5655738,5.12195122 C17.095082,5.12195122 15.7785246,5.76585366 14.8770492,6.7804878 C14.6640984,7.0204878 14.4777049,7.28292683 14.3144262,7.56097561 L15.4396721,7.56097561 C15.6186885,7.86585366 15.7578689,8.19463415 15.8680328,8.53658537 L13.8791803,8.53658537 C13.7793443,8.8502439 13.7070492,9.17512195 13.6731148,9.51219512 L16.072623,9.51219512 C16.0893443,9.67317073 16.1060656,9.83414634 16.1060656,10 C16.1060656,10.164878 16.0962295,10.3273171 16.08,10.4878049 L13.672623,10.4878049 C13.7065574,10.824878 13.7788525,11.1497561 13.8786885,11.4634146 L15.8734426,11.4634146 C15.7637705,11.8068293 15.6167213,12.1326829 15.4377049,12.4390244 L14.3139344,12.4390244 C14.4767213,12.7160976 14.6636066,12.9790244 14.8765574,13.2195122 C15.7780328,14.2341463 17.0945902,14.8780488 18.565082,14.8780488 C21.2808197,14.8780488 23.4831148,12.6936585 23.4831148,10 C23.4836066,7.30585366 21.2813115,5.12195122 18.5655738,5.12195122"
                      fill="#E9D419"
                    ></path>
                    <path
                      d="M27.1721311,0.731707317 C28.2570492,0.731707317 29.1393443,1.60682927 29.1393443,2.68292683 L29.1393443,17.3170732 C29.1393443,18.3931707 28.2570492,19.2682927 27.1721311,19.2682927 L2.58196721,19.2682927 C1.49704918,19.2682927 0.614754098,18.3931707 0.614754098,17.3170732 L0.614754098,2.68292683 C0.614754098,1.60682927 1.49704918,0.731707317 2.58196721,0.731707317 L27.1721311,0.731707317 M27.1721311,0.243902439 L2.58196721,0.243902439 C1.2295082,0.243902439 0.12295082,1.34146341 0.12295082,2.68292683 L0.12295082,17.3170732 C0.12295082,18.6585366 1.2295082,19.7560976 2.58196721,19.7560976 L27.1721311,19.7560976 C28.5245902,19.7560976 29.6311475,18.6585366 29.6311475,17.3170732 L29.6311475,2.68292683 C29.6311475,1.34146341 28.5245902,0.243902439 27.1721311,0.243902439"
                      fill="#7684B7"
                    ></path>
                  </g>
                </g>
              </svg>
              <svg viewBox="0 0 30 20">
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g id="icon-visa">
                    <path
                      d="M29.6311475,17.3170732 C29.6311475,18.6585366 28.5245902,19.7560976 27.1721311,19.7560976 L2.58196721,19.7560976 C1.2295082,19.7560976 0.12295082,18.6585366 0.12295082,17.3170732 L0.12295082,2.68292683 C0.12295082,1.34146341 1.2295082,0.243902439 2.58196721,0.243902439 L27.1721311,0.243902439 C28.5245902,0.243902439 29.6311475,1.34146341 29.6311475,2.68292683 L29.6311475,17.3170732"
                      fill="#F3F4F4"
                    ></path>
                    <path
                      d="M0.614754098,5.12195122 L0.614754098,2.68292683 C0.614754098,1.34146341 1.72131148,0.243902439 3.07377049,0.243902439 L26.6803279,0.243902439 C28.0327869,0.243902439 29.1393443,1.34146341 29.1393443,2.68292683 L29.1393443,5.12195122 L0.614754098,5.12195122"
                      fill="#5565AF"
                    ></path>
                    <path
                      d="M29.1393443,14.8780488 L29.1393443,17.3170732 C29.1393443,18.6585366 28.0327869,19.2682927 26.6803279,19.2682927 L3.07377049,19.2682927 C1.72131148,19.2682927 0.614754098,18.6585366 0.614754098,17.3170732 L0.614754098,14.8780488 L29.1393443,14.8780488"
                      fill="#E6A124"
                    ></path>
                    <path
                      d="M8.67393443,11.6482927 C8.87360656,11.0873171 9.01377049,10.7278049 9.09639344,10.5697561 L10.7562295,7.21609756 L11.9704918,7.21609756 L9.09639344,12.7878049 L7.81327869,12.7878049 L7.32540984,7.21609756 L8.45901639,7.21609756 L8.6547541,10.5697561 C8.66459016,10.6839024 8.67,10.8536585 8.67,11.0765854 C8.66409836,11.3385366 8.65672131,11.5292683 8.64688525,11.6482927 L8.67393443,11.6482927"
                      fill="#5565AF"
                    ></path>
                    <path
                      d="M11.4634426,12.7878049 L12.662459,7.21609756 L13.8344262,7.21609756 L12.6354098,12.7878049 L11.4634426,12.7878049"
                      fill="#5565AF"
                    ></path>
                    <path
                      d="M17.4265574,11.1414634 C17.4265574,11.6731707 17.2362295,12.0921951 16.8580328,12.4009756 C16.4788525,12.7097561 15.964918,12.8639024 15.3172131,12.8639024 C14.7506557,12.8639024 14.2952459,12.7497561 13.9495082,12.5209756 L13.9495082,11.4765854 C14.4432787,11.7507317 14.902623,11.8882927 15.325082,11.8882927 C15.6113115,11.8882927 15.8360656,11.835122 15.997377,11.7263415 C16.1586885,11.6185366 16.2393443,11.4712195 16.2393443,11.282439 C16.2393443,11.1736585 16.2221311,11.077561 16.1877049,10.9946341 C16.1532787,10.9126829 16.1031148,10.8356098 16.0396721,10.7639024 C15.9752459,10.6926829 15.8168852,10.5639024 15.5631148,10.3756098 C15.2095082,10.1219512 14.9606557,9.87512195 14.817541,9.62682927 C14.6734426,9.3804878 14.6021311,9.11512195 14.6021311,8.8302439 C14.6021311,8.50243902 14.6808197,8.2102439 14.8401639,7.95170732 C14.9985246,7.69414634 15.2242623,7.49365854 15.5183607,7.3497561 C15.8114754,7.20634146 16.1483607,7.13463415 16.5309836,7.13463415 C17.0862295,7.13463415 17.5952459,7.2604878 18.0565574,7.51170732 L17.637541,8.3995122 C17.2381967,8.21170732 16.8693443,8.11756098 16.5309836,8.11756098 C16.317541,8.11756098 16.1439344,8.17463415 16.0086885,8.28926829 C15.872459,8.40341463 15.805082,8.55512195 15.805082,8.74292683 C15.805082,8.89804878 15.847377,9.03365854 15.9319672,9.14878049 C16.0165574,9.26439024 16.2059016,9.41756098 16.5004918,9.60780488 C16.8098361,9.81121951 17.042459,10.0356098 17.1959016,10.2804878 C17.3493443,10.5278049 17.4265574,10.8136585 17.4265574,11.1414634"
                      fill="#5565AF"
                    ></path>
                    <path
                      d="M21.1957377,11.4614634 L19.3785246,11.4614634 L18.717541,12.7878049 L17.4880328,12.7878049 L20.4309836,7.19317073 L21.8640984,7.19317073 L22.4286885,12.7878049 L21.2877049,12.7878049 L21.1957377,11.4614634 M21.1377049,10.4707317 L21.0378689,9.13707317 C21.0118033,8.80439024 20.9995082,8.48292683 20.9995082,8.17268293 L20.9995082,8.03560976 C20.8863934,8.3404878 20.7467213,8.66341463 20.5804918,9.00341463 L19.8580328,10.4707317 L21.1377049,10.4707317"
                      fill="#5565AF"
                    ></path>
                    <path
                      d="M27.2360656,19.755122 C27.214918,19.7556098 27.1932787,19.7560976 27.1721311,19.7560976 C27.1932787,19.7560976 27.214918,19.7556098 27.2360656,19.755122 M0.845409836,19.0395122 L0.845409836,19.0395122 C0.845409836,19.04 0.845901639,19.04 0.846393443,19.0404878 C0.845901639,19.04 0.845409836,19.04 0.845409836,19.0395122 M29.6311475,17.3326829 C29.6267213,18.015122 29.3360656,18.6326829 28.8732787,19.0746341 C28.885082,19.0629268 28.8968852,19.0512195 28.9086885,19.0395122 C29.3513115,18.6009756 29.6267213,17.997561 29.6311475,17.3326829 M28.9086885,0.960487805 L28.9086885,0.960487805 C28.9318033,0.983414634 28.954918,1.00682927 28.9770492,1.03073171 C28.954918,1.00682927 28.9322951,0.983414634 28.9086885,0.960487805"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M17.4880328,12.7878049 L20.4309836,7.19317073 L21.8640984,7.19317073 L22.4286885,12.7878049 L21.2877049,12.7878049 L21.1957377,11.4614634 L19.3785246,11.4614634 L18.717541,12.7878049 L17.4880328,12.7878049 M28.9086885,0.960487805 L28.5978689,1.1604878 C28.9362295,1.57853659 29.1393443,2.10829268 29.1393443,2.68292683 L29.1393443,5.12195122 L22.4488525,5.12195122 L17.7580328,8.14390244 L17.637541,8.3995122 C17.5819672,8.37365854 17.5278689,8.3497561 17.4737705,8.32731707 L16.0303279,9.25707317 C16.1336066,9.35512195 16.29,9.47219512 16.5004918,9.60780488 C16.8098361,9.81121951 17.042459,10.0356098 17.1959016,10.2804878 C17.3493443,10.5278049 17.4265574,10.8136585 17.4265574,11.1414634 C17.4265574,11.6731707 17.2362295,12.0921951 16.8580328,12.4009756 C16.4788525,12.7097561 15.964918,12.8639024 15.3172131,12.8639024 C14.7506557,12.8639024 14.2952459,12.7497561 13.9495082,12.5209756 L13.9495082,11.4765854 C14.4432787,11.7507317 14.902623,11.8882927 15.325082,11.8882927 C15.6113115,11.8882927 15.8360656,11.835122 15.997377,11.7263415 C16.1586885,11.6185366 16.2393443,11.4712195 16.2393443,11.282439 C16.2393443,11.1736585 16.2221311,11.077561 16.1877049,10.9946341 C16.1532787,10.9126829 16.1031148,10.8356098 16.0396721,10.7639024 C15.9752459,10.6926829 15.8168852,10.5639024 15.5631148,10.3756098 C15.3418033,10.2170732 15.1618033,10.0609756 15.0231148,9.90585366 L12.9713115,11.2282927 L12.6354098,12.7878049 L11.4634426,12.7878049 L11.6104918,12.104878 L7.3052459,14.8780488 L29.1393443,14.8780488 L29.1393443,17.3170732 C29.1393443,18.6585366 28.0327869,19.2682927 26.6803279,19.2682927 L3.07377049,19.2682927 C2.3704918,19.2682927 1.73360656,19.1034146 1.28459016,18.7565854 L0.845409836,19.0395122 C0.845409836,19.04 0.845901639,19.04 0.846393443,19.0404878 C1.29196721,19.482439 1.90622951,19.7560976 2.58196721,19.7560976 L27.1721311,19.7560976 C27.1932787,19.7560976 27.214918,19.7556098 27.2360656,19.755122 C27.8695082,19.7390244 28.4444262,19.482439 28.8732787,19.0746341 C29.3360656,18.6326829 29.6267213,18.015122 29.6311475,17.3326829 L29.6311475,17.3170732 L29.6311475,2.68292683 C29.6311475,2.67268293 29.6311475,2.66195122 29.6306557,2.65121951 C29.6227869,2.02780488 29.3754098,1.45902439 28.9770492,1.03073171 C28.954918,1.00682927 28.9318033,0.983414634 28.9086885,0.960487805"
                      fill="#F3F4F4"
                    ></path>
                    <path
                      d="M28.5978689,1.1604878 L22.4488525,5.12195122 L29.1393443,5.12195122 L29.1393443,2.68292683 C29.1393443,2.10829268 28.9362295,1.57853659 28.5978689,1.1604878"
                      fill="#5C6BB2"
                    ></path>
                    <path
                      d="M29.1393443,14.8780488 L7.3052459,14.8780488 L1.28459016,18.7565854 C1.73360656,19.1034146 2.3704918,19.2682927 3.07377049,19.2682927 L26.6803279,19.2682927 C28.0327869,19.2682927 29.1393443,18.6585366 29.1393443,17.3170732 L29.1393443,14.8780488"
                      fill="#E7A52D"
                    ></path>
                    <path
                      d="M12.9713115,11.2282927 L11.6104918,12.104878 L11.4634426,12.7878049 L12.6354098,12.7878049 L12.9713115,11.2282927"
                      fill="#5C6BB2"
                    ></path>
                    <path
                      d="M16.0303279,9.25707317 L15.0231148,9.90585366 C15.1618033,10.0609756 15.3418033,10.2170732 15.5631148,10.3756098 C15.8168852,10.5639024 15.9752459,10.6926829 16.0396721,10.7639024 C16.1031148,10.8356098 16.1532787,10.9126829 16.1877049,10.9946341 C16.2221311,11.077561 16.2393443,11.1736585 16.2393443,11.282439 C16.2393443,11.4712195 16.1586885,11.6185366 15.997377,11.7263415 C15.8360656,11.835122 15.6113115,11.8882927 15.325082,11.8882927 C14.902623,11.8882927 14.4432787,11.7507317 13.9495082,11.4765854 L13.9495082,12.5209756 C14.2952459,12.7497561 14.7506557,12.8639024 15.3172131,12.8639024 C15.964918,12.8639024 16.4788525,12.7097561 16.8580328,12.4009756 C17.2362295,12.0921951 17.4265574,11.6731707 17.4265574,11.1414634 C17.4265574,10.8136585 17.3493443,10.5278049 17.1959016,10.2804878 C17.042459,10.0356098 16.8098361,9.81121951 16.5004918,9.60780488 C16.29,9.47219512 16.1336066,9.35512195 16.0303279,9.25707317 M17.7580328,8.14390244 L17.4737705,8.32731707 C17.5278689,8.3497561 17.5819672,8.37365854 17.637541,8.3995122 L17.7580328,8.14390244"
                      fill="#5C6BB2"
                    ></path>
                    <path
                      d="M20.9995082,8.03560976 C20.8863934,8.3404878 20.7467213,8.66341463 20.5804918,9.00341463 L19.8580328,10.4707317 L21.1377049,10.4707317 L21.0378689,9.13707317 C21.0118033,8.80439024 20.9995082,8.48292683 20.9995082,8.17268293 L20.9995082,8.03560976"
                      fill="#F3F4F4"
                    ></path>
                    <path
                      d="M19.8580328,10.4707317 L20.5804918,9.00341463 C20.7467213,8.66341463 20.8863934,8.3404878 20.9995082,8.03560976 L20.9995082,8.17268293 C20.9995082,8.48292683 21.0118033,8.80439024 21.0378689,9.13707317 L21.1377049,10.4707317 L19.8580328,10.4707317 M21.8640984,7.19317073 L20.4309836,7.19317073 L17.4880328,12.7878049 L18.717541,12.7878049 L19.3785246,11.4614634 L21.1957377,11.4614634 L21.2877049,12.7878049 L22.4286885,12.7878049 L21.8640984,7.19317073"
                      fill="#5C6BB2"
                    ></path>
                    <path
                      d="M27.1721311,0.731707317 C28.2570492,0.731707317 29.1393443,1.60682927 29.1393443,2.68292683 L29.1393443,17.3170732 C29.1393443,18.3931707 28.2570492,19.2682927 27.1721311,19.2682927 L2.58196721,19.2682927 C1.49704918,19.2682927 0.614754098,18.3931707 0.614754098,17.3170732 L0.614754098,2.68292683 C0.614754098,1.60682927 1.49704918,0.731707317 2.58196721,0.731707317 L27.1721311,0.731707317 M27.1721311,0.243902439 L2.58196721,0.243902439 C1.2295082,0.243902439 0.12295082,1.34146341 0.12295082,2.68292683 L0.12295082,17.3170732 C0.12295082,18.6585366 1.2295082,19.7560976 2.58196721,19.7560976 L27.1721311,19.7560976 C28.5245902,19.7560976 29.6311475,18.6585366 29.6311475,17.3170732 L29.6311475,2.68292683 C29.6311475,1.34146341 28.5245902,0.243902439 27.1721311,0.243902439"
                      fill="#F9F9F9"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        v-for="field in formsData.fields"
        :key="field.id + field.type"
        class="form-field"
      >
        <currency-field
          v-if="pmtFormLoaded"
          :field="field"
          :min-amount="minAmount"
          :max-amount="paymentAmount"
          v-on:valid="amountSubmittable = $event"
          :show-error="errorChange"
          :disabled="currentlySubmitting || preventPartial"
        />
      </div>
      <!-- Inject Payment form here -->
      <div id="pmt"></div>
    </div>
    <section v-if="error" class="error" id="paymentError">
      <p>Payment failed.</p>
      <p>{{ errorDescription }}</p>
    </section>
    <section class="protective-lang">
      I authorize {{ paymentDetails.practiceName }} to charge the provided
      credit card for the Billing Reason indicated above. This payment
      authorization is for the specified amount only, is valid for one time use
      only, and is subject to any and all terms I have agreed to with
      {{ paymentDetails.practiceName }}. I understand that returns, refunds, and
      cancellations are not permitted, though exceptions may be made on a
      case-by-case basis. I certify that I am an authorized user of this credit
      card and that I will not dispute the payment with my credit card company
      so long as the transaction corresponds to these terms. <br />
      <br />
      <span
        v-if="
          !paymentDetails.termsAndConditionsLink &&
          paymentDetails.updoxPatientTermsOfServiceUrl &&
          paymentDetails.updoxPatientPrivacyLink
        "
      >
        Payment processing and associated data storage provided by Updox, a
        United States-based company. By completing checkout, I agree to the
        Updox
        <a
          id="updox-terms-of-service"
          class="compliance-link"
          :href="paymentDetails.updoxPatientTermsOfServiceUrl"
          title="Terms of Service"
          target="_blank"
          rel="noopener noreferrer"
          >Terms of Service</a
        >
        and
        <a
          id="updox-privacy-policy"
          class="compliance-link"
          :href="paymentDetails.updoxPatientPrivacyLink"
          title="Privacy Policy"
          target="_blank"
          rel="noopener noreferrer"
          >Privacy Policy</a
        >.
      </span>
      <span v-else-if="paymentDetails.termsAndConditionsLink">
        Payment processing and associated data storage provided by Updox, a
        United States-based company. By completing checkout, I agree to the
        {{ paymentDetails.practiceName }}
        <a
          id="practice-terms-and-conditions"
          class="compliance-link"
          :href="paymentDetails.termsAndConditionsLink"
          :title="paymentDetails.termsAndConditionsLink"
          target="_blank"
          >Terms and Conditions</a
        >
        <span
          v-if="
            paymentDetails.updoxPatientTermsOfServiceUrl &&
            paymentDetails.updoxPatientPrivacyLink
          "
        >
          and the Updox
          <a
            id="updox-terms-of-service"
            class="compliance-link"
            :href="paymentDetails.updoxPatientTermsOfServiceUrl"
            title="Terms of Service"
            target="_blank"
            rel="noopener noreferrer"
            >Terms of Service</a
          >
          and
          <a
            id="updox-privacy-policy"
            class="compliance-link"
            :href="paymentDetails.updoxPatientPrivacyLink"
            title="Privacy Policy"
            target="_blank"
            rel="noopener noreferrer"
            >Privacy Policy</a
          > </span
        >.
      </span>
    </section>
    <section class="form-actions">
      <updox-button
        type="submit"
        text="Submit Payment"
        aria-label="Submit Payment"
        id="submitFormButton"
        @click.prevent="onSubmit"
        :loading="currentlySubmitting"
        :disabled="currentlySubmitting || !pmtSubmittable || !amountSubmittable"
      />
    </section>
  </div>
</template>

<script>
  import CurrencyField from "./common/CurrencyField";
  import SimplePaymentsPatientService from "../services/SimplePaymentsPatientService";
  import { UpdoxButton } from "@updox/common-vue";
  import { formatCurrencyInput } from "@/utils/formatting";
  import _ from "lodash";

  export default {
    name: "PaymentRemitForm",
    components: {
      CurrencyField,
      UpdoxButton,
    },
    props: {
      formsData: {
        fields: {
          type: Array,
          required: true,
        },
      },
      paymentDetails: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      submitted: false,
      error: false,
      errorDescription: "",
      currentlySubmitting: false,
      errorChange: false,
      pmtFormLoaded: false,
      pmtSubmittable: false,
      amountSubmittable: true,
    }),
    async mounted() {
      const { paymentRequestToken } = this.$route.params;

      let pmtHostScript = document.createElement("script");

      const dontUseSandbox = _.endsWith(
        window.location.origin,
        "pay.myupdox.com"
      );
      pmtHostScript.setAttribute(
        "src",
        dontUseSandbox
          ? "https://api.paysimple.com/pmt/v1/host/host.js"
          : "https://sandbox-api.paysimple.com/pmt/v1/host/host.js"
      );

      document.head.appendChild(pmtHostScript);

      // The instance of this vue class
      const vm = this;

      console.debug("paymentRequestToken = ", paymentRequestToken);
      console.debug("merchantKey = ", vm.merchantKey);

      pmtHostScript.onload = function () {
        // @TODO do we want acceptInternationalPostalCodes?
        const pmt = window.paymentMethodTokenization({
          container: document.querySelector("#pmt"),
          merchantKey: vm.merchantKey,
          styles: vm.pmtFormStyles,
          localization: vm.pmtFormLocalization,
        });

        pmt.trigger.setMode("cc-input");

        pmt.on("validity-changed", function (message) {
          if (message?.valid === false) {
            vm.pmtFormLoaded = true;

            // pmt init does not include setting <iframe> attributes
            if (vm.pmtFormLoaded) {
              document
                .getElementsByTagName("iframe")[0]
                .setAttribute("title", "pmt-form");
            }
          }
          vm.pmtSubmittable = message?.valid;
        });

        let timer = setInterval(() => {
          try {
            if (!vm.pmtFormLoaded) {
              console.log("starting-detection");
              pmt.trigger.setFormToSubmitted();
              pmt.trigger.resetForm();
              console.log("ending-detection");
              clearInterval(timer);
            }
          } catch (exception) {
            console.error(exception);
          }
        }, 100);

        vm.handleSubmitForm = function () {
          pmt.trigger.submitForm();
        };

        // Logic to post to your server, which will then post to PaySimple
        // to make a payment or vault the card goes here.
        // This event fires after pmt.trigger.submitForm()
        pmt.on("add-payment-method-succeeded", function (response) {
          console.debug("add-payment-method-succeeded ", response);

          // Just use an object as the api expects "amount" key. Merge it with the response.
          const paymentAmount = {
            amount: formatCurrencyInput(vm.formsData.fields[0].value),
          };
          const paymentSaleRequest = _.merge(paymentAmount, response);

          const { paymentRequestToken } = vm.$route.params;
          console.debug("sending paymentSaleRequest... ", paymentSaleRequest);

          // Chain the APIs: Step 2, makeCreditCardSale
          SimplePaymentsPatientService.makeCreditCardSale(
            paymentRequestToken,
            paymentSaleRequest
          )
            .then((response) => {
              if (response?.status === "OK") {
                console.debug("makeCreditCardSale response = ", response);
                // Push to /receipt when payment sale is complete
                vm.resetForm(pmt, vm);
                vm.$router.push(`/receipt/${paymentRequestToken}`);
              } else if (
                response?.status === "PAYMENT_TOKEN_TIMEOUT" ||
                response?.status === "FAILED"
              ) {
                vm.error = true;
                vm.errorDescription = response?.failedReason;
              } else {
                vm.$emit("parent-status", response?.status);
              }
            })
            .catch((e) => {
              vm.$emit("parent-error", e);
            })
            .finally(() => {
              vm.currentlySubmitting = false;
            });
        });

        pmt.on("add-payment-method-failed", function (message) {
          // Logic to display error message goes here
          vm.error = true;
          vm.currentlySubmitting = false;
          console.error("add-payment-method-failed ", message);

          const paymentActivityRequest = {
            result: "FAILED",
            message: message.message,
            code: message.statusCode,
            object: JSON.stringify(message.error),
          };
          SimplePaymentsPatientService.addPaymentActivity(
            paymentRequestToken,
            paymentActivityRequest
          )
            .then((response) => {
              let status = response.status;
              console.log(status);
              if (status != "OK") {
                // TBD: PAYMENT_INVALID_STATE, TOKEN_NOT_FOUND, PRACTICE_UNABLE_TO_PROCESS
              }
            })
            .catch((e) => {
              console.log(e);
            });
        });
      };
    },
    computed: {
      form: function () {
        if (this.formsData !== undefined && this.formsData !== null) {
          return this.formsData;
        } else {
          return null;
        }
      },
      // get the $store paymentDetails saved from getPaymentDetails()
      paymentRequestDate() {
        return this.$store.getters.paymentRequestDate;
      },
      paymentAmount() {
        return this.$store.getters.paymentAmount;
      },
      preventPartial() {
        return this.$store.getters.preventPartial;
      },
      minAmount() {
        return this.$store.getters.minAmount;
      },
      merchantKey() {
        return this.$store.getters.merchantKey;
      },
      // pmt form css init
      pmtFormStyles() {
        return {
          body: {
            margin: 0,
            padding: 0,
          },
          // Styles the labels
          label: {
            // Default styles that every label will get
            default: {
              "font-weight": "600",
              "font-size": "14px",
              "margin-bottom": "4px",
              display: "block",
              "min-height": "inherit",
            },
            // Other labels:
            // for Credit Card: cardholderName, expiration, cvv, postalCode
            // for ACH: accountHolder, routingNumber, accountNumber, accountType, companyName
          },
          // Styles the inputs
          input: {
            // Default styles that every input will get
            default: {
              margin: "0",
              display: "block",
              width: "100%",
              "box-sizing": "border-box",
              padding: "8px",
              "font-size": "14px",
              "max-width": "100%",
              background: "#fff",
              color: "#000",
              border: "1px solid #d4d8db",
              "border-radius": "4px",
              "-webkit-appearance": "textfield",

              // Allows you to style the :placeholder pseudo style
              ":placeholder": {
                "font-size": "12px",
              },
            },

            // Labels:
            // for Credit Card: cardholderName, cardNumber, expiration, cvv, postalCode
            // for ACH: accountHolder, routingNumber, accountNumber, companyName
          },
          // Styles the validation messages
          validation: {
            // Default styles that every validation message will get
            default: {
              color: "#cc0000",
              "font-size": "10px",
              "font-style": "italic",
              "margin-top": "6px",
            },
            // Validation messages:
            // for Credit Card: cardholderName, cardNumber, expiration, cvv, postalCode
            // for ACH: accountHolder, routingNumber, accountNumber, accountType, companyName
          },
        };
      },
      pmtFormLocalization() {
        return {
          placeholder: {
            cardholderName: "Cardholder Name",
            cardNumber: "Credit Card",
            expiration: "MM/YY",
            cvv: "CVV",
            postalCode: "Zip/Postal Code",
          },
        };
      },
    },
    methods: {
      formatAmountStr(amount) {
        return Number(amount).toFixed(2);
      },
      // Chain the APIs: Step 1, pmt.trigger.submitForm() andThen makeCreditCardSale
      onSubmit: _.debounce(function () {
        this.currentlySubmitting = true;

        const paymentAmountRequested = this.paymentAmount;
        const currentPaymentAmount = formatCurrencyInput(
          this.formsData.fields[0].value
        );

        let proceed = true;
        if (currentPaymentAmount < paymentAmountRequested) {
          proceed = window.confirm(
            "The Amount entered is less than what is requested. Are you sure?"
          );
        }

        if (proceed) {
          this.handleSubmitForm();
        } else {
          this.currentlySubmitting = false;
        }
      }, 500),
      resetForm(pmtScope, vueScope) {
        pmtScope.trigger.resetForm();
        vueScope.submitted = false;
        vueScope.error = false;
        vueScope.formsData.fields.forEach((item) => (item.value = null));
      },
    },
  };
</script>

<style scoped lang="scss">
/*We need to import the global styles for each view in order for the compiled web component to inherit the global and updox-styles styling*/
@import "@/assets/_scss/main";

  .payment-preview {
    background: rgb(237, 246, 249);
    border: 1px solid rgba(0, 127, 173, 0.2);
    border-radius: 4px;

    .requested-details {
      padding: 10px;

      .flex-column {
        &:last-child {
          text-align: right;
        }
      }

      h2 {
        font-weight: 600;
        margin: 0;
      }

      small {
        color: rgb(68, 68, 68);
        font-size: 12px;
        font-weight: 400;
        font-style: italic;
      }
    }

    .payment-details {
      font-size: 14px;
      padding: 7px 7px 0;

      p {
        margin: 0;

        &:first-child {
          font-weight: 600;
        }
      }
    }

    .options {
      border-top: 1px solid rgba(0, 127, 173, 0.2);
      margin-top: 10px;

      small {
        color: rgb(68, 68, 68);
        font-size: 10px;
        font-weight: 400;
        font-style: italic;
      }

      .container {
        align-items: center;
        padding: 10px;
      }

      .cards {
        svg {
          height: 30px;
          margin-right: 8px;
          width: 30px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .form-container {
    background-color: #fff;
    padding: 15px;

    p {
      margin-top: 0;
    }

    .form-field {
      display: flex;
      flex-direction: column;
      margin-bottom: 32px;
      margin-top: 32px;
      position: relative;

      ::v-deep #label-amount {
        font-size: 14px;
      }

      &:first-child {
        margin-top: 0;
      }
    }

    .form-body {
      ::placeholder {
        font-size: 12px;
      }
    }

    .protective-lang {
      font-size: 12px;
      font-style: italic;
      margin-bottom: 12px;
    }

    .form-actions {
      p {
        font-size: 12px;
        margin: 0;
      }
    }
  }

  section.error {
    background: #ffeded;
    border: 1px solid rgba(173, 0, 0, 0.2);
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 5px;
  }

  .compliance-link {
    text-decoration: underline;
  }
</style>
